<div class="container-div d-flex flex-column">
  <div class="d-flex justify-content-between align-items-center">
    <span class="heading-text">Merge History</span>
    <div class="img-container" mat-dialog-close>
      <img
        src="../../../assets/images/crossIconDarkTheme.svg"
        class="cross-icon"
      />
    </div>
  </div>
  @for(item of data;track item){
  <div class="content-div d-flex flex-column">
    @for(fc of item.fcDetails;track fc){
    <div class="content d-flex justify-content-between">
      <span class="heading-class">Family Code -{{ $index + 1 }}</span>
      <span class="heading-content">{{ fc.fCode }}</span>
    </div>
    <div class="content d-flex justify-content-between">
      <span class="heading-class">Member Name</span>
      <span class="heading-content">{{ fc.memberName }}</span>
    </div>

    <div class="content d-flex justify-content-between">
      <span class="heading-class">Status</span>
      <span class="heading-content">{{ fc.currentStatus }}</span>
    </div>
    <span class="separator-div"></span>
    }
  </div>
  }
</div>
